import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'
import * as Config from '../config/Config'

import {queryBearerToken} from './UserAuthentication'
import {getDomainInCartList} from "../selectors/CartUtil";
import {toggleSelectionTriggered} from "./Util";

// **************************************************************************************************************
const fetchTopLevelDomains = (bearer) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.TOPLEVELDOMAINS_REQUEST, ActionTypes.TOPLEVELDOMAINS_SUCCESS, ActionTypes.TOPLEVELDOMAINS_FAILURE],
        endpoint: `topleveldomains`,
        bearer: bearer,
        schema: Schemas.TOPLEVELDOMAINS,
        method: 'GET'
    }
})

export const queryTopLevelDomains = () => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchTopLevelDomains(getState().token.bearer))
    })
}

const fetchDomainCheck = (bearer, domainName, domainEnding) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.DOMAIN_CHECK_REQUEST, ActionTypes.DOMAIN_CHECK_SUCCESS, ActionTypes.DOMAIN_CHECK_FAILURE],
        endpoint: `domains/${domainName}.${domainEnding}/actions/check`,
        bearer: bearer,
        schema: Schemas.STATUSCODE,
        method: 'POST',
        payload: {
            domainName: domainName,
            domainEnding: domainEnding
        }
    }
})

export const queryDomainCheck = (domainName, domainEnding) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchDomainCheck(getState().token.bearer, domainName, domainEnding))
    })
}

export const domainInputChange = (value) => ({
    type: ActionTypes.DOMAIN_INPUT_CHANGE,
    value: value
})

export const beginDomainCheck = () => (dispatch, getState) => {
    return dispatch({type: ActionTypes.DOMAIN_CHECK_BEGIN})
}

export const queryInitialDomains = () => (dispatch, getState) => {

    // fetch initial 10 top domains and further domains
    const queriedDomain = getState().domainCheck.queriedDomain
    const queriedDomainEnding = getState().domainCheck.queriedDomainEnding
    const furtherDomainLimit = getState().domainCheck.furtherDomainLimit
    const domainOrder = getState().domainCheck.topLevelDomains.order
    const domainData = getState().domainCheck.topLevelDomains.data

    let domainsToCheck = []
    let topDomainsToAdd = Config.DOMAIN_AMOUNT_TOPDOMAINS

    if (queriedDomainEnding !== "" && domainData[queriedDomainEnding]) {
        domainsToCheck.push(queriedDomainEnding)
        topDomainsToAdd--;
    }

    for (let i = 0; i < topDomainsToAdd + furtherDomainLimit; i++) {
        if (domainOrder[i] === queriedDomainEnding) {
            topDomainsToAdd++
        } else {
            domainsToCheck.push(domainOrder[i])
        }
    }

    // perform loading calls for the top domains
    domainsToCheck.forEach(domainEnding => {
        dispatch(queryDomainCheck(queriedDomain, domainEnding))
    })

}

const loadMoreDomains = () => ({
    type: ActionTypes.DOMAIN_LOAD_MORE
})

export const queryMoreDomains = () => (dispatch, getState) => {

    // store old limit before dispatching load more action
    const oldLimit = getState().domainCheck.furtherDomainLimit

    dispatch(loadMoreDomains())

    const newLimit = getState().domainCheck.furtherDomainLimit
    const queriedDomain = getState().domainCheck.queriedDomain
    const queriedDomainEnding = getState().domainCheck.queriedDomainEnding
    const domainOrder = getState().domainCheck.topLevelDomains.order

    let domainsToCheck = []
    let offset = 0
    const topDomainsAdded = Config.DOMAIN_AMOUNT_TOPDOMAINS
    const queriedDomainOffset = queriedDomainEnding === '' ? 0 : 1

    for (let i = 0; i < topDomainsAdded + newLimit - queriedDomainOffset; i++) {

        // find index to skip (queriedDomainEnding in front, not reflected in order)
        if (queriedDomainOffset && !offset && domainOrder[i] === queriedDomainEnding) {
            offset = 1
        }

        if (i + queriedDomainOffset >= topDomainsAdded + oldLimit) {
            domainsToCheck.push(domainOrder[i + offset])
        }

    }

    // perform loading calls for the bottom domains
    domainsToCheck.forEach(domainEnding => {
        dispatch(queryDomainCheck(queriedDomain, domainEnding))
    })

}

export const toggleHideDomainsGone = () => (dispatch, getState) => {
    dispatch(
        {
            type: ActionTypes.DOMAIN_HIDE_GONE
        }
    )
}

export const selectDomainTypeIfNoDomainsInCart = (domainType) => (dispatch, getState) => {
    const domainsInCartList = getDomainInCartList(getState());
    if (domainsInCartList.length === 0) {
        dispatch(toggleSelectionTriggered('domainType', domainType))
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/Domain.js
 **/